// extracted by mini-css-extract-plugin
module.exports = {"owner":"owner__3xtEn","status":"status__wRz5e"};